import { 
  FETCH_CALCULATIONS_CONFIG_SUCCESS,
  FETCH_CALCULATIONS_CONFIG_PENDING,
  FETCH_CALCULATIONS_CONFIG_ERROR,
} from '../constants/Constants';

const initialState = {
  pending: false,
  data: [],
  error: ''
}

export const requestCalculationsConfig = (state = initialState, action) => {
  switch(action.type) {
      case FETCH_CALCULATIONS_CONFIG_PENDING:
          return {
              ...state,
              pending: true
          }
      case FETCH_CALCULATIONS_CONFIG_SUCCESS:
          return {
              ...state,
              pending: false,
              data: action.payload
          }
      case FETCH_CALCULATIONS_CONFIG_ERROR:
          return {
              ...state,
              pending: false,
              error: action.payload
          }
      default: 
          return state;
  }
}
